import React from "react";
import "./offersCard.css";
import offerimg from "../../assets/images/card/offers.png";
import { Link } from "react-router-dom";

const OfferCard = ({data}) => {
  return (
    <div className="offerCard">
      <img className="offer-img w-100 h-100 rounded " src={offerimg} />
      <Link to={'/offers'}>
        <div className="offer-text-container " >
          <div className="offer-text ">
          {data}
          </div>
          
        </div>
        <div className="d-flex justify-content-center book-now-btn-container w-100 ">
            <btn className="search-button  text-center  book-now-btn fw-bold ">Book Now</btn>
          </div>
      
      </Link>
    </div>
  );
};

export default OfferCard;
